var React = require('react');

function HoldOrange (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 378.703C0 378.703 45.238 418.528 130.239 387.221C215.241 355.914 347.933 282.76 347.933 282.76C347.933 282.76 451.717 197.992 389.962 114.503C328.207 31.0138 206.5 0.956797 206.5 0.956797C206.5 0.956797 121.488 -7.77377 68.7388 63.1602C15.9893 134.094 0 378.703 0 378.703Z","fill":"#FF9518"}));
}

HoldOrange.defaultProps = {"width":"410","height":"400","viewBox":"0 0 410 400","fill":"none"};

module.exports = HoldOrange;

HoldOrange.default = HoldOrange;
